// extracted by mini-css-extract-plugin
export default {"chart":"bg_Pn","fullscreen":"bg_dL","close":"bg_pR"};